"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalHeaderHeight = exports.getPageHeaderHeight = void 0;
const tslib_1 = require("tslib");
const InternalConstants = tslib_1.__importStar(require("./InternalConstants"));
const getPageHeaderHeight = (headerSize) => {
    if (headerSize === "large") {
        return Math.round(InternalConstants.PAGE_HEADER_HEIGHT * 1.5);
    }
    return InternalConstants.PAGE_HEADER_HEIGHT;
};
exports.getPageHeaderHeight = getPageHeaderHeight;
const getTotalHeaderHeight = (headerSize) => InternalConstants.ARGUS_MENU_HEIGHT + (0, exports.getPageHeaderHeight)(headerSize);
exports.getTotalHeaderHeight = getTotalHeaderHeight;
